import React from 'react';
import { Row, Col } from 'antd';
import { ComponentSpinner } from '../shared/ComponentSpinner';
import { EXPORT_LOADING_ATTRIBUTE } from './captureDashboardSections';

interface Props {
    title: string;
    loading?: boolean;
}

export const WidgetCardHeader = ({ title, loading }: Props) => {
    return (
        <>
            <Row wrap={false} align="middle" className="f-card-header f-gap-1">
                <Col flex="auto">
                    <div className="f-card-title">{title}</div>
                </Col>
            </Row>
            {loading && (
                // Marked so the PDF export waits for the widget to finish loading before capturing.
                <Col flex="none" {...{ [EXPORT_LOADING_ATTRIBUTE]: 'true' }}>
                    <ComponentSpinner />
                </Col>
            )}
        </>
    );
};
